import { getEntity } from '../entities/selectors';

export const getPart = (state, partId) => getEntity(state, 'parts', partId);

export const getPartModel = (state, partId) =>
  getEntity(state, 'partModels', partId);
